// Sessão 4.9.2 — Modal que envolve o WidgetOportunidadesEscondidas
// Motivação: widget virou discreto no header, só abre quando clicado.

import React from 'react';
import { X } from 'lucide-react';
import WidgetOportunidadesEscondidas from './WidgetOportunidadesEscondidas';

const OportunidadesEscondidasModal = ({ onClose, onCriarOferta, onOpenEmail }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-40 flex items-start justify-center pt-16 px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-[95vw] 2xl:max-w-7xl max-h-[95vh] overflow-auto">
        <div className="flex items-center justify-between p-3 border-b sticky top-0 bg-white">
          <div className="text-xs uppercase tracking-wide text-slate-500">Radar</div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X size={18} />
          </button>
        </div>
        <div className="p-3">
          <WidgetOportunidadesEscondidas
            onCriarOferta={(empresaId, empresaNome) => {
              onClose();
              onCriarOferta?.(empresaId, empresaNome);
            }}
            onOpenEmail={(em) => {
              onClose();
              onOpenEmail?.(em);
            }}
            minEmails={2}
            maxItens={50}
          />
        </div>
      </div>
    </div>
  );
};

export default OportunidadesEscondidasModal;
